import { render, staticRenderFns } from "./blogPosts.vue?vue&type=template&id=680750d9&scoped=true&"
import script from "./blogPosts.vue?vue&type=script&lang=js&"
export * from "./blogPosts.vue?vue&type=script&lang=js&"
import style0 from "./blogPosts.vue?vue&type=style&index=0&id=680750d9&prod&lang=css&"
import style1 from "./blogPosts.vue?vue&type=style&index=1&id=680750d9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680750d9",
  null
  
)

export default component.exports